var map = {
	"./footer_wave.svg": "c037",
	"./header_wave.svg": "8cce",
	"./ornaments_bottom.png": "2117",
	"./ornaments_top.png": "b486",
	"./p_sponsor_bg.png": "74ea",
	"./sample_logo.png": "1a4c",
	"./sponsor_RPC.png": "c01e",
	"./sponsor_footer.png": "830c",
	"./sponsor_header.png": "a5f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "591d";